import {
  legacyKeyToRelativePath,
  listLegacyStorageKeysForSlug
} from "./chunk-3TOUJ5O5.js";
import {
  EXXAT_STORAGE_PREFIX
} from "./chunk-HA5JJMF5.js";
import {
  runWithoutBuilderDevSync
} from "./chunk-UEG4HCRI.js";

// src/tenant-products/storage-snapshot.ts
function collectStorageSnapshotForSlug(slug) {
  if (typeof window === "undefined") return {};
  const out = {};
  for (const fullKey of listLegacyStorageKeysForSlug(slug)) {
    try {
      const value = window.localStorage.getItem(fullKey);
      if (value == null) continue;
      out[legacyKeyToRelativePath(fullKey)] = value;
    } catch {
    }
  }
  return out;
}
function restoreStorageSnapshot(snapshot) {
  if (!snapshot || typeof window === "undefined") return;
  const entries = Object.entries(snapshot);
  runWithoutBuilderDevSync(() => {
    for (const [relativePath, value] of entries) {
      const fullKey = relativePath.startsWith(EXXAT_STORAGE_PREFIX) ? relativePath : `${EXXAT_STORAGE_PREFIX}${relativePath}`;
      try {
        window.localStorage.setItem(fullKey, value);
      } catch {
      }
    }
  });
}

export {
  collectStorageSnapshotForSlug,
  restoreStorageSnapshot
};
